import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getHotelById } from "../../../../Redux/slice/features/hotelDetailsSlice";
import { setAvailabilityData } from "../../../../Redux/slice/features/availabilitySlice";
import { MdPlace } from "react-icons/md";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const HotelDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { hotelById } = useSelector((state) => state.hotelDetails);
  const [rooms, setRooms] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [selectedTotalPerson, setSelectedTotalPerson] = useState("");
  const [selectedExtraPerson, setSelectedExtraPerson] = useState();
  const [totalPersons, setTotalPersons] = useState([]);
  const [selectedChild, setSelectedChild] = useState("0");
  const [customerName, setCustomerName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [emailId, setEmailId] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [childAges, setChildAges] = useState([]);
  const [extraPersons, setExtraPersons] = useState([]);
  const { user } = useSelector((state) => state.auth.user);
  const [pendingPayment, setPendingPayment] = useState(null);
  const [isConfirming, setIsConfirming] = useState(false);
  const {
    availableRooms,
    check_in_date: reduxCheckInDate,
    check_out_date: reduxCheckOutDate,
  } = useSelector((state) => state.availability);
  const check_in_date =
    reduxCheckInDate || localStorage.getItem("checkInDate") || "";
  const check_out_date =
    reduxCheckOutDate || localStorage.getItem("checkOutDate") || "";
  
  const date1 = new Date(check_in_date);
  const date2 = new Date(check_out_date);

  const timeDiff = date2 - date1;
  const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  const pendingBookingStorageKey = id && check_in_date && check_out_date
      ? `pendingHotelBooking:${user?.customerId || "guest"}:${id}:${check_in_date}:${check_out_date}`
      : null;
  const paymentBackRedirectKey = id
    ? `redirectHotelBookingBack:${id}`
    : null;

  useEffect(() => {
    const resetReturnedPayment = () => {
      if (
        !paymentBackRedirectKey ||
        sessionStorage.getItem(paymentBackRedirectKey) !== "true"
      ) {
        return;
      }

      sessionStorage.removeItem(paymentBackRedirectKey);
      if (pendingBookingStorageKey) {
        localStorage.removeItem(pendingBookingStorageKey);
      }

      sessionStorage.removeItem("currentBookingRef");
      sessionStorage.removeItem("currentOrderId");
      sessionStorage.removeItem("customerName");
      sessionStorage.removeItem("bookingAmount");

      setPendingPayment(null);
      setIsConfirming(false);
      setRooms([]);
      setSelectedRoomType("");
      setSelectedTotalPerson("");
      setSelectedExtraPerson("");
      setTotalPersons([]);
      setExtraPersons([]);
      setSelectedChild("0");
      setChildAges([]);
      setCustomerName("");
      setMobileNo("");
      setEmailId("");
      setCustomerAddress("");
    };

    resetReturnedPayment();
    window.addEventListener("pageshow", resetReturnedPayment);

    return () => {
      window.removeEventListener("pageshow", resetReturnedPayment);
    };
  }, [paymentBackRedirectKey, pendingBookingStorageKey]);

  useEffect(() => {
    if (!pendingBookingStorageKey) {
      setPendingPayment(null);
      return;
    }

    const restorePendingPayment = () => {
      try {
        const savedPayment = localStorage.getItem(pendingBookingStorageKey);
        setPendingPayment(savedPayment ? JSON.parse(savedPayment) : null);
      } catch (error) {
        console.error("Unable to restore pending payment:", error);
        localStorage.removeItem(pendingBookingStorageKey);
        setPendingPayment(null);
      }
    };

    const handleStorageChange = (event) => {
      if (event.key === pendingBookingStorageKey) {
        restorePendingPayment();
      }
    };

    restorePendingPayment();
    window.addEventListener("storage", handleStorageChange);

    return () => window.removeEventListener("storage", handleStorageChange);
  }, [pendingBookingStorageKey]);

  useEffect(() => {
    const fetchAvailability = async () => {
      if (!id || !check_in_date || !check_out_date) {
        return;
      }

      try {
        const response = await axios.post(
          `${REACT_APP_API_URL}api/checkAvailibilty/${id}`,
          {
            check_in_date,
            check_out_date,
          },
        );

        const availability = Array.isArray(response.data?.data)
          ? response.data.data
          : [];
        const roomTariffs = Array.isArray(response.data?.roomConfigs)
          ? response.data.roomConfigs
          : [];
        const mergedRooms = availability.map((room) => {
          const matchingTariff = roomTariffs.find(
            (tariff) => tariff.RoomTypeId === room.RoomConfigID,
          );

          return {
            ...room,
            ...(matchingTariff || {}),
          };
        });

        dispatch(
          setAvailabilityData({
            rooms: mergedRooms,
            check_in_date,
            check_out_date,
          }),
        );
      } catch (error) {
        console.error("Error restoring room availability:", error);
      }
    };

    fetchAvailability();
  }, [check_in_date, check_out_date, dispatch, id]);

  const handleChildAgeChange = (index, value) => {
    const newChildAges = [...childAges];
    newChildAges[index] = value;
    setChildAges(newChildAges);
  };
  const calculateSubtotal = () => {
    return rooms.reduce((total, room) => {
      const roomSubtotal =
        parseFloat(room.pricePerDay) * dayDiff +
        parseFloat(room.extraPersonRate) *
          parseInt(room.selectedExtraPerson || 0) *
          dayDiff;
      return total + roomSubtotal;
    }, 0);
  };

  const subtotal = calculateSubtotal();
  const gst = subtotal * 0.05;
  const totalPayable = subtotal + gst;

  const getBookedRoomsCount = (roomConfigId) =>
    rooms.filter((room) => room.roomConfigId === roomConfigId).length;

  const addRoom = () => {
    if (rooms.length >= 4) {
      alert("You can only book up to 4 rooms.");
      return;
    }

    if (!selectedRoomType) {
      alert("Please select a room type before adding.");
      return;
    }

    const roomDetails = availableRooms.find(
      (room) => room.RoomConfig === selectedRoomType,
    );

    if (!roomDetails) {
      alert("Selected room details not found.");
      return;
    }

    const availableCount = parseInt(roomDetails.AvailableRooms, 10) || 0;
    const alreadySelectedCount = getBookedRoomsCount(roomDetails.RoomConfigID);
    if (alreadySelectedCount >= availableCount) {
      alert(
        `Only ${availableCount} room(s) are available for ${roomDetails.RoomConfig}.`,
      );
      return;
    }

    const newRoom = {
      id: Date.now(),
      name: `Room ${rooms.length + 1}`,
      type: roomDetails.RoomConfig,
      roomConfigId: roomDetails.RoomConfigID,
      pricePerDay: roomDetails.PricePerDay,
      extraPersonRate: roomDetails.ExtraPersonRate,
      selectedTotalPerson: parseInt(selectedTotalPerson || 0),
      selectedExtraPerson: parseInt(selectedExtraPerson || 0),
      selectedChild: selectedChild,
      childAges: childAges.join(", "),
    };

    setRooms((prevRooms) => [...prevRooms, newRoom]);
    setSelectedRoomType("");
    setSelectedTotalPerson("");
    setSelectedExtraPerson("");
    setSelectedChild("0");
    setChildAges([]);
  };

  const handleRoomTypeChange = (e) => {
    const selectedRoom = e.target.value;
    setSelectedRoomType(selectedRoom);

    const roomDetails = availableRooms.find(
      (room) => room.RoomConfig === selectedRoom,
    );

    if (roomDetails) {
      setTotalPersons(
        Array.from({ length: roomDetails.PersonAllowed }, (_, i) => i + 1),
      );
      setExtraPersons(
        Array.from({ length: roomDetails.ExtraPerson }, (_, i) => i + 1),
      );
    } else {
      setTotalPersons([]);
      setExtraPersons([]);
    }
  };
  const handleTotalPersonChange = (e) => {
    setSelectedTotalPerson(e.target.value);
  };

  const handleExtraPersonChange = (e) => {
    setSelectedExtraPerson(e.target.value);
    console.log("selectedExtraPerson", selectedExtraPerson);
  };

  const deleteRoom = (id) => {
    setRooms(rooms.filter((room) => room.id !== id));
  };

  useEffect(() => {
    dispatch(getHotelById(id));
    console.log("called dispatch");
  }, [dispatch, id]);

  const convertToXML = (rooms, dayDiff) => {
    console.log("rooms under xml", rooms);
    let xml = `<ArrayOfRoomDetails>\n`;
    const stayDays = Number.isFinite(dayDiff) && dayDiff > 0 ? dayDiff : 1;

    rooms.forEach((room, index) => {
      console.log("room under xml", room);
      const price = parseFloat(room.pricePerDay || 0);
      const extraRate = parseFloat(room.extraPersonRate || 0);
      const extraPersonCount = parseInt(room.selectedExtraPerson || 0, 10);
      const subtotal = (price + extraPersonCount * extraRate) * stayDays;

      xml += `  <RoomDetails>
          <SlNo>${index + 1}</SlNo>
          <RoomType>${room.type || ""}</RoomType>
          <RoomTypeId>${room.roomConfigId || 0}</RoomTypeId>
          <Adult>${room.selectedTotalPerson || 0}</Adult>
          <child>${room.selectedChild || 0}</child>
          <TotalRoom>1</TotalRoom>
          ${
            room.childAges
              ? `<age1>${room.childAges.split(", ")[0] || 0}</age1>
                 <age2>${room.childAges.split(", ")[1] || 0}</age2>`
              : `<age1>0</age1><age2>0</age2>`
          }
          <Price>${price.toFixed(2)}</Price>
          <TotalPrice>${subtotal.toFixed(2)}</TotalPrice>
          <intExtraPerson>${room.selectedExtraPerson || 0}</intExtraPerson>
          <NoOfExtraPerson>${room.selectedExtraPerson || 0}</NoOfExtraPerson>
          <ExtraPersonRate>${
            (room.selectedExtraPerson || 0) * extraRate
          }.00</ExtraPersonRate>
          <ExtraBed>${room.extraBed || 0}</ExtraBed>
          <ExtraBedRate>${parseFloat(room.extraBedRate || 0).toFixed(
            2,
          )}</ExtraBedRate>
        </RoomDetails>\n`;
    });

    xml += `</ArrayOfRoomDetails>`;
    return xml;
  };

  const submitBooking = async () => {
    if (pendingPayment || isConfirming) {
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    if (!customerName || customerName.trim().length < 2) {
      window.alert("Please enter a valid customer name.");
      return;
    }

    if (!emailRegex.test(emailId)) {
      window.alert("Please enter a valid email address.");
      return;
    }

    if (!mobileRegex.test(mobileNo)) {
      window.alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (!check_in_date || !check_out_date) {
      window.alert("Please select both check-in and check-out dates.");
      return;
    }

    if (!customerAddress || customerAddress.trim().length < 5) {
      window.alert("Please provide a valid address.");
      return;
    }

    const overbookedRoom = availableRooms.find((roomType) => {
      const availableCount = parseInt(roomType.AvailableRooms, 10) || 0;
      const selectedCount = rooms.filter(
        (room) => room.roomConfigId === roomType.RoomConfigID,
      ).length;
      return selectedCount > availableCount;
    });

    if (overbookedRoom) {
      window.alert(
        `Booking exceeds availability for ${overbookedRoom.RoomConfig}. Please remove extra room(s).`,
      );
      return;
    }

    const roomXml = convertToXML(rooms, dayDiff);
    const subtotal = calculateSubtotal();
    const gst = subtotal * 0.05;
    const totalPayable = subtotal + gst;

    const taxDataXML = `
<ArrayOfTaxDetails>
  <TaxDetails>
    <TaxID>1</TaxID>
    <TaxType>Subtotal</TaxType>
    <TaxAmount>${totalPayable.toFixed(2)}</TaxAmount>
    <PropertyId>2</PropertyId>
  </TaxDetails>
  <TaxDetails>
    <TaxID>2</TaxID>
    <TaxType>+</TaxType>
    <TaxAmount>0.00</TaxAmount>
    <PropertyId>3</PropertyId>
  </TaxDetails>
  <TaxDetails>
    <TaxID>3</TaxID>
    <TaxType>Payable Amount</TaxType>
    <TaxAmount>${totalPayable.toFixed(2)}</TaxAmount>
    <PropertyId>4</PropertyId>
  </TaxDetails>
</ArrayOfTaxDetails>`.trim();

    const bookingData = {
      CustomerName: customerName,
      CustomerType: 3,
      EmailID: emailId,
      CheckIn: check_in_date,
      checkOUT: check_out_date,
      MobileNo: mobileNo,
      IdentityNo: "",
      IdentityType: "",
      CustomerAddress: customerAddress,
      hotelID: id,
      UserInfo: "",
      CustomerId: "",
      grandTotal: subtotal,
      createdBy: user?.customerId,
      gst: gst,
      totalPayable: totalPayable.toFixed(2),
      tableData: roomXml,
      TaxData: taxDataXML,
    };

    setIsConfirming(true);

    try {
      const payment = await createHostedCheckout(bookingData);
      setPendingPayment(payment);

      if (pendingBookingStorageKey) {
        localStorage.setItem(pendingBookingStorageKey, JSON.stringify(payment));
      }
    } catch (error) {
      console.error("Booking confirmation failed:", error);
      window.alert("Booking confirmation failed. Please try again.");
    } finally {
      setIsConfirming(false);
    }
  };

  const createHostedCheckout = async (bookingData) => {
    const response = await axios.post(
      `${REACT_APP_API_URL}api/preview/hotel-booking`,
      bookingData,
    );

    const { orderId, amount, key, bookingRef } = response.data;

    if (!orderId || !amount || !key || !bookingRef) {
      throw new Error("Invalid response from server");
    }

    const payment = {
      orderId,
      amount,
      key,
      bookingRef,
      customerName,
      emailId,
      mobileNo,
    };

    sessionStorage.setItem("currentBookingRef", bookingRef);
    sessionStorage.setItem("currentOrderId", orderId);
    sessionStorage.setItem("customerName", customerName);
    sessionStorage.setItem("bookingAmount", (amount / 100).toString());

    return payment;
  };

  const proceedToPayment = () => {
    if (!pendingPayment) {
      window.alert("Please confirm the booking first.");
      return;
    }

    try {
      if (paymentBackRedirectKey) {
        sessionStorage.setItem(paymentBackRedirectKey, "true");
      }

      const {
        orderId,
        amount,
        key,
        bookingRef,
        customerName: confirmedCustomerName,
        emailId: confirmedEmailId,
        mobileNo: confirmedMobileNo,
      } = pendingPayment;

      sessionStorage.setItem("currentBookingRef", bookingRef);
      sessionStorage.setItem("currentOrderId", orderId);
      sessionStorage.setItem("customerName", confirmedCustomerName);
      sessionStorage.setItem("bookingAmount", (amount / 100).toString());

      const form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute(
        "action",
        "https://api.razorpay.com/v1/checkout/embedded",
      );

      const fields = {
        key_id: key,
        order_id: orderId,
        name: "JTDCL",
        description: `Hotel Booking for ${confirmedCustomerName}`,
        prefill: {
          name: confirmedCustomerName,
          email: confirmedEmailId,
          contact: confirmedMobileNo,
        },
        notes: {
          booking_ref: bookingRef,
          customer_name: confirmedCustomerName,
          source: "dashboard",
        },
        callback_url: `${REACT_APP_API_URL}api/payment/razorpay-payment-success?bookingRef=${bookingRef}`,
        cancel_url: `${window.location.origin}/hotels/${id}?payment=cancelled`,
      };

      Object.entries(fields).forEach(([key, value]) => {
        if (typeof value === "object") {
          Object.entries(value).forEach(([nestedKey, nestedValue]) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = `${key}[${nestedKey}]`;
            input.value = nestedValue;
            form.appendChild(input);
          });
        } else {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        }
      });

      const additionalFields = {
        amount: amount.toString(),
        currency: "INR",
        theme_color: "#3399cc",
      };

      Object.entries(additionalFields).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);

      window.requestAnimationFrame(() => {
        window.history.pushState(
          { hotelBookingReturn: true },
          "",
          window.location.href,
        );
        form.submit();

        setTimeout(() => {
          document.body.removeChild(form);
        }, 100);
      });
    } catch (error) {
      console.error("Error while proceeding to payment:", error);
      window.alert("Failed to open payment. Please try again.");
    }
  };

  return (
    <>
      <div className="container mt-5 p-1">
        {/*hotel fetch About hotel details section */}
        <div id="aboutHotelDetails">
          <div className="bg-white shadow-lg rounded p-3 hotelDiv">
            <header className="d-flex justify-content-between align-items-start">
              <div className="hotel-info">
                <h3 className="fw-bold text-dark">
                  {hotelById ? hotelById[0].UnitName : ""}
                </h3>
                <p
                  className="text-muted d-flex align-items-center"
                  style={{ fontSize: "1rem" }}
                >
                  <MdPlace className="text-primary me-2" />
                  {hotelById ? hotelById[0].Address : ""}
                </p>
              </div>
            </header>

            <div className="row g-3 mt-4">
              {/* Left Section */}

              {/* Right Section */}
            </div>
            <div className="card">
              <div className="card-header">
                <h6 className="card-title">Customer Details</h6>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12 d-flex">
                    <div className="card flex-fill w-100 border">
                      <div className="card-header py-3">
                        <h6 className="card-title">Guest Details</h6>
                      </div>
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label text-muted">
                                Mobile No.
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="bi bi-phone"></i>
                                </span>
                                <span
                                  className="input-group-text sm"
                                  style={{ fontSize: "0.6rem" }}
                                >
                                  +91
                                </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Mobile No."
                                  value={mobileNo}
                                  max={10}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (
                                      /^[6-9]\d{0,9}$/.test(val) ||
                                      val === ""
                                    ) {
                                      setMobileNo(val);
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label text-muted">
                                Guest Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="bi bi-person-circle"></i>
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Guest Name"
                                  value={customerName}
                                  onChange={(e) =>
                                    setCustomerName(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label text-muted">
                                Email
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="bi bi-envelope"></i>
                                </span>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="example@email.com"
                                  value={emailId}
                                  onChange={(e) => setEmailId(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="form-label text-muted">
                                Address
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Address"
                                value={customerAddress}
                                onChange={(e) =>
                                  setCustomerAddress(e.target.value)
                                }
                              ></textarea>
                            </div>
                          </div>
                          {check_in_date && check_out_date && (
                            <div className="mb-2">
                              <span className="badge bg-info text-dark me-2">
                                Check-in: {check_in_date}
                              </span>
                              <span className="badge bg-warning text-dark">
                                Check-out: {check_out_date}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 d-flex">
                    <div className="card flex-fill w-100 border">
                      <div className="card-header py-3">
                        <h6 className="card-title">Room Details</h6>
                      </div>
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label text-muted">
                                Room Type
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="bi bi-house"></i>
                                </span>
                                <select
                                  className="form-select"
                                  value={selectedRoomType}
                                  onChange={handleRoomTypeChange}
                                >
                                  <option value="">Choose Room Type</option>
                                  {availableRooms.map((room) => (
                                    <option
                                      key={room.RoomConfigID}
                                      value={room.RoomConfig}
                                    >
                                      {room.RoomConfig}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label text-muted">
                                Total Person
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i class="bi bi-person-plus"></i>
                                </span>
                                <select
                                  className="form-select"
                                  value={selectedTotalPerson}
                                  onChange={handleTotalPersonChange}
                                >
                                  <option value="">Choose No.Of Person</option>
                                  {totalPersons.map((num) => (
                                    <option key={num} value={num}>
                                      {num}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label text-muted">
                                Extra Person
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i class="bi bi-person-plus"></i>
                                </span>
                                <select
                                  className="form-select"
                                  value={selectedExtraPerson}
                                  onChange={handleExtraPersonChange}
                                >
                                  <option value="">
                                    Choose No.Of Extra Person
                                  </option>
                                  {extraPersons.map((num) => (
                                    <option key={num} value={num}>
                                      {num}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label text-muted">
                                Child
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i class="bi bi-person-plus"></i>
                                </span>
                                <select
                                  className="form-select"
                                  value={selectedChild}
                                  onChange={(e) => {
                                    setSelectedChild(e.target.value);
                                    setChildAges(
                                      Array(parseInt(e.target.value)).fill(""),
                                    );
                                  }}
                                >
                                  <option value="0">No. of Children</option>
                                  {[1, 2].map((num) => (
                                    <option key={num} value={num}>
                                      {num}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>

                          {selectedChild > 0 && (
                            <div className="col-md-12">
                              <div className="form-group">
                                <label className="form-label text-muted">
                                  Child Age(s)
                                </label>
                                {Array.from({
                                  length: parseInt(selectedChild),
                                }).map((_, index) => (
                                  <select
                                    key={index}
                                    className="form-select mt-2"
                                    value={childAges[index] || ""}
                                    onChange={(e) =>
                                      handleChildAgeChange(
                                        index,
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="">Select Age</option>
                                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(
                                      (age) => (
                                        <option key={age} value={age}>
                                          {age} yrs
                                        </option>
                                      ),
                                    )}
                                  </select>
                                ))}
                              </div>
                            </div>
                          )}
                          <div className="container">
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <button
                                  type="button"
                                  className="btn btn-primary mt-2"
                                  onClick={addRoom}
                                >
                                  Add Room
                                </button>
                              </div>
                            </div>

                            {rooms.length > 0 && (
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Room Type</th>
                                    <th>Adult(s)</th>
                                    <th>Child(s)</th>
                                    <th>Child1 Age</th>
                                    <th>Child2 Age</th>
                                    <th>Price Per Day</th>
                                    <th>No. of Extra Person</th>
                                    <th>Extra Person Rate</th>
                                    <th>Subtotal</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rooms.map((room, index) => (
                                    <tr key={room.id}>
                                      <td>{index + 1}</td>
                                      <td>{room.type}</td>
                                      <td>{room.selectedTotalPerson}</td>
                                      <td>{room.selectedChild}</td>
                                      <td>
                                        {room.childAges
                                          ? room.childAges.split(", ")[0]
                                          : "-"}
                                      </td>
                                      <td>
                                        {room.childAges &&
                                        room.childAges.split(", ").length > 1
                                          ? room.childAges.split(", ")[1]
                                          : "N/A"}
                                      </td>
                                      <td>{room.pricePerDay}</td>
                                      <td>{room.selectedExtraPerson || 0}</td>
                                      <td>
                                        {parseInt(room.extraPersonRate) *
                                          parseInt(
                                            room.selectedExtraPerson || 0,
                                          )}
                                      </td>
                                      <td>
                                        {parseInt(room.pricePerDay) * dayDiff +
                                          parseInt(room.extraPersonRate) *
                                            parseInt(
                                              room.selectedExtraPerson || 0,
                                            ) *
                                            dayDiff}
                                      </td>
                                      <td>
                                        <button
                                          className="btn btn-danger"
                                          onClick={() => deleteRoom(room.id)}
                                        >
                                          Delete
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <div className="card">
                              <div className="card-header">
                                <h6 className="card-title">
                                  Payment Breakdown
                                </h6>
                              </div>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="payment-breakdown">
                                      <div className="breakdown-item">
                                        <label>Subtotal:</label>
                                        <span>₹{subtotal.toFixed(2)}</span>
                                        {rooms.length > 0 && (
                                          <ul
                                            style={{
                                              fontSize: "0.95em",
                                              margin: "8px 0 0 0",
                                              padding: 0,
                                              listStyle: "none",
                                            }}
                                          >
                                            {rooms.map((room, idx) => {
                                              const pricePerDay =
                                                parseFloat(room.pricePerDay) ||
                                                0;
                                              const extraPerson = parseInt(
                                                room.selectedExtraPerson || 0,
                                              );
                                              const extraRate =
                                                parseFloat(
                                                  room.extraPersonRate,
                                                ) || 0;
                                              const roomTotal =
                                                pricePerDay * dayDiff +
                                                extraPerson *
                                                  extraRate *
                                                  dayDiff;
                                              return (
                                                <li
                                                  key={room.id}
                                                  style={{ marginBottom: 2 }}
                                                >
                                                  <span
                                                    style={{ color: "#555" }}
                                                  >
                                                    Room {idx + 1}: {room.type}{" "}
                                                    — {dayDiff} day(s) x ₹
                                                    {pricePerDay} +
                                                    {extraPerson > 0
                                                      ? ` ${extraPerson} extra x ₹${extraRate} x ${dayDiff} day(s)`
                                                      : " no extra person"}{" "}
                                                    = ₹{roomTotal}
                                                  </span>
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        )}
                                      </div>
                                      <div className="breakdown-item">
                                        <label>GST (5%):</label>
                                        <span>₹{gst.toFixed(2)}</span>
                                      </div>
                                      <div className="breakdown-item total">
                                        <label>Total Payable:</label>
                                        <span>₹{totalPayable.toFixed(2)}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {pendingPayment && (
                            <div className="col-6 text-center">
                              <div className="alert alert-success py-2">
                                Booking with. Reference:{" "}
                                <strong>{pendingPayment.bookingRef}</strong>
                              </div>
                            </div>
                          )}
                          <button
                            className={`btn ${
                              pendingPayment ? "btn-success" : "btn-primary"
                            } d-block mx-auto my-auto`}
                            onClick={
                              pendingPayment ? proceedToPayment : submitBooking
                            }
                            disabled={isConfirming}
                            style={{
                              width: "200px",
                              height: "50px",
                            }}
                          >
                            {isConfirming
                              ? "Confirming..."
                              : pendingPayment
                                ? "Proceed to Payment"
                                : "Confirm Booking"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HotelDetails;
